import React, { useEffect, useState } from 'react';
import { Fill } from '../../shared/utils/fill';
import { FillControl } from '../../shared/ui/fill-control';
import { PillTextbox } from '../types';
import { setPillFill, setPillTextFill } from '../utils/pill-accessors';
import { usePillContent } from '../hooks/use-pill-content';
import { rowStyle, sectionStyle } from './pill-styles';
import { PILL_INSERT_DEFAULTS } from '../constants/defaults';

type Props = { pill: PillTextbox };

export const PillColorRow: React.FC<Props> = ({ pill }) => {
  const { content, patch } = usePillContent(pill);
  const [fill, setFillState] = useState<Fill>({ kind: 'solid', color: PILL_INSERT_DEFAULTS.fill });
  const [textFill, setTextFillState] = useState<Fill>({ kind: 'solid', color: PILL_INSERT_DEFAULTS.textFill });

  useEffect(() => {
    if (!content) return;
    setFillState({ kind: 'solid', color: content.fill || PILL_INSERT_DEFAULTS.fill });
    setTextFillState({ kind: 'solid', color: content.textFill || PILL_INSERT_DEFAULTS.textFill });
  }, [content]);

  const previewFill = (v: Fill) => {
    setFillState(v);
    if (v.kind === 'solid') setPillFill(pill, v.color);
  };

  const previewTextFill = (v: Fill) => {
    setTextFillState(v);
    if (v.kind === 'solid') setPillTextFill(pill, v.color);
  };

  const commitFill = (v: Fill) => {
    previewFill(v);
    if (v.kind === 'solid') patch({ fill: v.color });
  };

  const commitTextFill = (v: Fill) => {
    previewTextFill(v);
    if (v.kind === 'solid') patch({ textFill: v.color });
  };

  return (
    <div style={sectionStyle}>
      <div style={rowStyle}>
        <FillControl value={fill} onPreview={previewFill} onCommit={commitFill} label='Relleno' gradient={false} />
        <FillControl
          value={textFill}
          onPreview={previewTextFill}
          onCommit={commitTextFill}
          label='Texto'
          gradient={false}
        />
      </div>
    </div>
  );
};
